import { Linking } from 'react-native';

export const getInitialURL = () => Linking.getInitialURL();

export type WatchLinkingCallback = (url: string) => void;

export const watchLinkingURL =
    (_callback: WatchLinkingCallback): (() => void) =>
    () => {}; // not supported on web
